import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase 
const app = initializeApp(firebaseConfig);

// App Check debug token (Firebase Console → App Check → Manage debug tokens).
// Must be set on globalThis before initializeAppCheck — see:
// https://firebase.google.com/docs/app-check/web/debug-provider
const appCheckDebugToken = process.env.REACT_APP_FIREBASE_APP_CHECK_DEBUG_TOKEN;
const isLocalDev =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';
const isUuidToken = (value) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    String(value || '')
  );

// Never enable App Check debug token on deployed environments.
if (appCheckDebugToken && process.env.NODE_ENV !== 'production' && isLocalDev) {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = appCheckDebugToken;
}

// App Check requires a reCAPTCHA v3 site key (Firebase Console → App Check → Web).
// Omit REACT_APP_FIREBASE_APP_CHECK_SITE_KEY only for local UI work; callable functions
// that enforce App Check will still need a debug token or this key configured.
const appCheckSiteKey = process.env.REACT_APP_FIREBASE_APP_CHECK_SITE_KEY;
if (appCheckSiteKey && !isUuidToken(appCheckSiteKey)) {
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(appCheckSiteKey),
      isTokenAutoRefreshEnabled: true
    });
  } catch (error) {
    console.warn('Firebase App Check initialization failed:', error);
  }
} else if (process.env.NODE_ENV === 'production') {
  const reason = appCheckSiteKey
    ? 'contains a debug token UUID, not a reCAPTCHA v3 site key'
    : 'is missing from the build';
  // Callable functions with enforceAppCheck:true return 401 { error: { status: "UNAUTHENTICATED" } } when no token is sent.
  console.error(
    `[Firebase] REACT_APP_FIREBASE_APP_CHECK_SITE_KEY ${reason}. App Check is not initialized; Cloud Functions will reject requests with UNAUTHENTICATED.`
  );
}

// Initialize Firebase services
const auth = getAuth(app);
const db = getDatabase(app);
const functions = getFunctions(app, 'us-central1');
const storage = getStorage(app);

export { auth, db, functions, storage }; 